import { handleError } from 'globals/errors';
import {
  createIsUrlAllowedResponse,
  isUrlDenied,
  validateIsUrlAllowedParameters,
} from './helpers';
import { IsUrlAllowedParameters, IsUrlAllowedResponse } from './types';

export const isUrlAllowed = (
  parameters: IsUrlAllowedParameters,
): IsUrlAllowedResponse | undefined => {
  try {
    const validationError = validateIsUrlAllowedParameters(parameters);

    if (validationError) {
      throw validationError;
    }

    const url = parameters?.url;
    const allowed = !isUrlDenied(url);
    return createIsUrlAllowedResponse(allowed);
  } catch (error) {
    handleError(error, { message: 'Failed to determine if url is allowed' });
  }

  return undefined;
};
